import { CartContainerItemFragment } from '@/features/graphql/generated/graphql'

export interface CartContainerItemWithIndex {
    item: CartContainerItemFragment
    index: number
}

export const appendCartContainerItem = (
    items: CartContainerItemFragment[] = [],
    item: CartContainerItemFragment
): CartContainerItemFragment[] => items.concat(item)

export const insertCartContainerItem = (
    items: CartContainerItemFragment[] = [],
    item: CartContainerItemFragment,
    index: number
): CartContainerItemFragment[] => items.toSpliced(index, 0, item)

export const removeCartContainerItem = (
    items: CartContainerItemFragment[] = [],
    itemUuid: string
): CartContainerItemFragment[] => items.filter(({ uuid }) => uuid !== itemUuid)

export const upsertCartContainerItem = (
    items: CartContainerItemFragment[] = [],
    item: CartContainerItemFragment
): CartContainerItemFragment[] => {
    const index = items.findIndex(({ uuid }) => uuid === item.uuid)

    if (index === -1) return [...items, item]

    return items.toSpliced(index, 1, item)
}

export const findCartContainerItemWithIndex = (
    items: CartContainerItemFragment[] = [],
    itemUuid: string
): CartContainerItemWithIndex | undefined => {
    const index = items.findIndex(({ uuid }) => uuid === itemUuid)

    if (index === -1) return undefined

    return { item: items[index], index }
}
